//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';

    angular.module('container.widgets')
        .directive('srsngButton', srsngButton);

    function srsngButton() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/button/button.html',
            scope: {
                text: '@',
                symbol: '@',
                clickEvent: '&'
            },
            controller: controller,
            link: link

        };

        function controller($scope, $filter) {
            $scope.btnClass = "standard";
            $scope.locked = false;
        }

        function link(scope, element, attrs) {
            if ("link" in attrs) scope.btnClass = "link";
            else if ("submit" in attrs) scope.btnClass = "submit";
            else if ("inactive" in attrs) scope.btnClass = "inactive";
            else if ("linkInactive" in attrs) scope.btnClass = "link-inactive";
            else if ("darkBackground" in attrs) scope.btnClass = "dark-background";
            else scope.btnClass = "standard";

            if ("locked" in attrs) scope.locked = true;

            if ("inactive" in attrs) {

                var updateInactive = function updateInactive(val) {

                    var inactive = val.toLowerCase() === 'true';
                };

                attrs.$observe('inactive', function (val) {
                    updateInactive(val);
                });
            }
        }
    }

})();

